export const RedCloseBgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="57"
    fill="none"
    viewBox="0 0 57 57"
    {...props}>
    <rect
      width="48"
      height="48"
      x="4.898"
      y="4.305"
      fill="#FEE4E2"
      rx="24"></rect>
    <rect
      width="48"
      height="48"
      x="4.898"
      y="4.305"
      stroke="#FEF3F2"
      strokeWidth="8"
      rx="24"></rect>
    <path
      stroke="#D32F2F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M31.798 18.305h-5.8c-.68 0-1.64.4-2.12.88l-4.1 4.1c-.48.48-.88 1.44-.88 2.12v5.8c0 .68.4 1.64.88 2.12l4.1 4.1c.48.48 1.44.88 2.12.88h5.8c.68 0 1.64-.4 2.12-.88l4.1-4.1c.48-.48.88-1.44.88-2.12v-5.8c0-.68-.4-1.64-.88-2.12l-4.1-4.1c-.48-.48-1.44-.88-2.12-.88zM25.398 31.805l7-7M32.398 31.805l-7-7"></path>
  </svg>
);
